import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PreShipState {
  preShipData: any;
  // ... other state properties
}

const initialState: PreShipState = {
  preShipData: {},
  // ... other initial state
};

const preShipSlice = createSlice({
  name: 'preShip',
  initialState,
  reducers: {
    setPreShipData: (state, action: PayloadAction<any>) => {
      state.preShipData = action.payload;
    },
    // ... other reducers
  }
});

export const { setPreShipData } = preShipSlice.actions;
export default preShipSlice.reducer; 